export default "__VITE_ASSET__Bxw8B0b8__"